const e1 = document.querySelector(".services__btn-info1"),
  t1 = document.querySelector(".services__card1");
e1.addEventListener("click", () => {
    t1.classList.toggle("services__card--visible");
});

const e2 = document.querySelector(".services__btn-info2"),
  t2 = document.querySelector(".services__card2");
e2.addEventListener("click", () => {
    t2.classList.toggle("services__card--visible");
});

const e3 = document.querySelector(".services__btn-info3"),
  t3 = document.querySelector(".services__card3");
e3.addEventListener("click", () => {
    t3.classList.toggle("services__card--visible");
});

